<ntv-modal
    class="edit-dealer-modal"
    [isVisible]="isVisible()"
    (modalClose)="onClose()"
    size="xlarge"
    modalHeight="auto"
    [showHeader]="false"
    [showFooter]="false">
    <div class="edit-dealer">
        <div class="edit-dealer__header">
            <div>
                <h2 class="edit-dealer__title">Dealer Details:</h2>
                <p class="edit-dealer__subtitle">You can update dealer details here</p>
            </div>
        </div>

        @if (saveError()) {
            <p class="edit-dealer__error" role="alert">{{ saveError() }}</p>
        }

        <form class="edit-dealer__form" [formGroup]="dealerForm" (ngSubmit)="onUpdate()">
            <div class="edit-dealer__grid">
                @for (field of formFields(); track field.fieldName) {
                    @if (field.fieldName === 'emailAddress') {
                        <div class="edit-dealer__field edit-dealer__field--email-actions">
                            <div class="edit-dealer__email-actions">
                                <ntv-input
                                    [label]="field.label"
                                    formControlName="emailAddress"
                                    [placeholder]="field.placeholder"
                                    type="email"
                                    [error]="getFieldErrorMessage('emailAddress')[0]"></ntv-input>
                                <div class="edit-dealer__reset-password">
                                    <label class="edit-dealer__label edit-dealer__label--secondary"
                                        >&nbsp;</label
                                    >
                                    <div class="flex items-center gap-3">
                                        <ntv-button
                                            color="custom"
                                            customColor="#091635"
                                            size="xl"
                                            rounded="md"
                                            [disabled]="resetPasswordDisabled()"
                                            [attr.title]="resetPasswordTooltip() || null"
                                            [attr.aria-disabled]="resetPasswordDisabled()"
                                            (buttonClick)="onResetPassword()">
                                            Change password
                                        </ntv-button>
                                        @if (resetPasswordCooldownSeconds() > 0) {
                                            <span class="edit-dealer__cooldown-timer">
                                                {{ resetPasswordCooldownDisplay() }}
                                            </span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    } @else {
                        <div
                            class="edit-dealer__field"
                            [class]="'edit-dealer__field--' + field.gridSpan"
                            [class.edit-dealer__field--read-only-display]="
                                isReadOnlyProfileLocationField(field.fieldName)
                            ">
                            @if (field.type === 'autocomplete') {
                                <app-autocomplete
                                    [options]="cityList()"
                                    [loading]="isLoadingCities()"
                                    [selectionIdentityProp]="'selectionKey'"
                                    size="xl"
                                    [config]="{
                                        placeholder: 'Type a city or state (min: 3-4 characters)',
                                        label: 'City',
                                    }"
                                    [formControlName]="field.fieldName"
                                    [error]="getFieldErrorMessage(field.fieldName)[0]"
                                    (onSelect)="onSelect($event)"
                                    (onSearch)="onSearch($event)" />
                            } @else {
                                <ntv-input
                                    [label]="field.label"
                                    [formControlName]="field.fieldName"
                                    [placeholder]="field.placeholder"
                                    [type]="$any(field.type)"
                                    [maxLength]="isContactNumberField(field.fieldName) ? 10 : null"
                                    (keydown)="onNumericKeydown($event, field.fieldName)"
                                    [error]="getFieldErrorMessage(field.fieldName)[0]"></ntv-input>
                            }
                        </div>
                    }
                }
            </div>
        </form>

        <div class="edit-dealer__actions">
            <div class="edit-dealer__actions-left">
                @if (canSubmitUpdate()) {
                    <ntv-button
                        color="custom"
                        customColor="#8dcb2c"
                        size="xl"
                        rounded="md"
                        (buttonClick)="onUpdate()">
                        Update
                    </ntv-button>
                } @else {
                    <ntv-button variant="ghost" size="xl" rounded="md" [disabled]="true">
                        Update
                    </ntv-button>
                }
                <ntv-button
                    color="custom"
                    customColor="#091635"
                    size="xl"
                    rounded="md"
                    (buttonClick)="onCancel()">
                    Cancel
                </ntv-button>
            </div>
            <ntv-button variant="danger" size="xl" rounded="md" (buttonClick)="onDelete()">
                Delete Dealer
            </ntv-button>
        </div>
    </div>
</ntv-modal>

@if (showPasswordLimitReached() && isVisible()) {
    <app-confirmation-modal
        class="edit-dealer__confirmation-overlay"
        [isVisible]="true"
        type="warning"
        size="small"
        [title]="passwordLimitTitle()"
        [message]="passwordLimitMessage()"
        confirmText="OK"
        [showCancelButton]="false"
        (confirm)="onDismissPasswordLimit()"
        (modalClose)="onDismissPasswordLimit()">
    </app-confirmation-modal>
}

@if (showPasswordResetSuccess() && isVisible()) {
    <app-confirmation-modal
        class="edit-dealer__confirmation-overlay"
        [isVisible]="true"
        type="success"
        size="small"
        [title]="passwordResetSuccessTitle()"
        [message]="passwordResetSuccessMessage()"
        confirmText="OK"
        [showCancelButton]="false"
        (confirm)="onDismissPasswordResetSuccess()"
        (modalClose)="onDismissPasswordResetSuccess()">
    </app-confirmation-modal>
}

@if (showDeleteConfirm() && isVisible()) {
    <app-confirmation-modal
        class="edit-dealer__confirmation-overlay"
        [isVisible]="true"
        [showCancelButton]="true"
        [loopAnimation]="false"
        [isLoading]="isDeleting()"
        type="warning"
        size="medium"
        title="Delete Dealer"
        [message]="
            'Are you sure you want to delete ' +
            (dealer().businessName || 'this dealer') +
            '? This action cannot be undone.'
        "
        confirmText="Delete"
        cancelText="Cancel"
        (confirm)="onConfirmDelete()"
        (cancel)="onCloseDeleteConfirm()"
        (modalClose)="onCloseDeleteConfirm()">
    </app-confirmation-modal>
}
